import React from 'react'

import GlobalPropsProvider from '../utils/stateProvider'

import globalState from '../../helpers/globalState'
import { darkGray, white, lightGray } from '../../helpers/colors'

import Styles from '../../styles/components/menuButton.module.scss'
const {
  menuHamburgerButton,
  menuCloseButton,
  menuLoadingButton,
  // menuWrapper,
  menuAccentLine,
  menuButtonLines,
} = Styles

const backgroundColor = white
const shapeColor = darkGray

class MenuButton extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      hover: false,
    }

    this.lastTop = 0

    this.toggleOpen = this.toggleOpen.bind(this)
    // this.onKeyPress = this.onKeyPress.bind(this);
    this.onScroll = this.onScroll.bind(this)
  }

  componentDidMount() {
    // window.addEventListener('keypress', this.onKeyPress);
    window.addEventListener('scroll', this.onScroll)
  }

  // componentWillUnmount() {
  //   window.removeEventListener('keypress', this.onKeyPress);
  // }

  // onKeyPress(e) {
  //   if (e.code === 'KeyM') {
  //     this.toggleOpen();
  //   } else if (e.code === 'KeyL') {
  //     globalState.setState({ loading: !globalState.state.loading });
  //   }
  // }

  onScroll(e) {
    if (!this.props.menuOpen) {
      const currentTop =
        document.documentElement.scrollTop + document.body.scrollTop
      const delta = currentTop - this.lastTop
      if (delta !== 0) {
        globalState.setState({
          scrolledUp: delta <= 0 && currentTop > 500,
        })
      }
      this.lastTop = currentTop
    }
  }

  toggleOpen() {
    globalState.setState({ menuOpen: !globalState.state.menuOpen })
  }

  render() {
    const { menuOpen, loading, menuHover } = this.props
    // const { hover } = this.state;

    /* <div
      onClick={() => {
        globalState.setState({ menuOpen: false, loading: false });
      }}
      style={{
        zIndex: 99999,
        position: 'fixed',
        right: 150,
        top: 0,
        color: 'white',
        background: 'black',
        cursor: 'pointer',
      }}
    >
      menu
    </div>
    <div
      onClick={() => {
        globalState.setState({ menuOpen: true, loading: false });
      }}
      style={{
        zIndex: 99999,
        position: 'fixed',
        right: 150,
        top: 50,
        color: 'white',
        background: 'black',
        cursor: 'pointer',
      }}
    >
      close
    </div>
    <div
      onClick={() => {
        globalState.setState({ loading: true });
      }}
      style={{
        zIndex: 99999,
        position: 'fixed',
        right: 150,
        top: 100,
        color: 'white',
        background: 'black',
        cursor: 'pointer',
      }}
    >
      loading
    </div> */
    const accentLineProps = {}
    if (!loading && menuOpen) {
      accentLineProps['transform'] = 'translate(0,35)'
    }
    return (
      // <div className={menuWrapper}>

      <div
        onClick={this.toggleOpen}
        onMouseEnter={() => {
          // globalState.setState({ menuHover: true });
          // this.setState({ ...this.state, hover: true });
        }}
        onMouseLeave={() => {
          // globalState.setState({ menuHover: false });
          // this.setState({ ...this.state, hover: false });
        }}
        className={
          loading
            ? menuLoadingButton
            : menuOpen ? menuCloseButton : menuHamburgerButton
        }
      >
        <svg viewBox="0 0 122.35162 95.943878" width="98" height="79">
          <path
            fill={backgroundColor}
            d="m 26.40825,5e-4 0,69.53625 -26.40875,26.4075 122.3525,0 0,-95.94375 -95.94375,0 z"
          />
          <path
            className={menuAccentLine}
            fill={shapeColor}
            d="m 49.269531,63.287109 0,6.25 16.169922,0 8.941406,8.949219 8.939453,-8.949219 16.169922,0 0,-6.25 -18.759765,0 -6.34961,6.355469 -6.351562,-6.355469 -18.759766,0 z"
            {...accentLineProps}
          />
        </svg>
        <div className={menuButtonLines} />
      </div>
      // </div>
    )
  }
}

export default GlobalPropsProvider(MenuButton, state => ({
  menuOpen: state.menuOpen,
  loading: state.loading,
  // scrolledUp: state.scrolledUp,
}))



// WEBPACK FOOTER //
// ./src/components/header/menu-button.js